var _symbol, _symbol2, _symbol3, _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCytiva(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2",
    "data-name": "Group 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      display: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "orbit-around",
    viewBox: "0 0 44 44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.55 16.45 17 23.9 15.05 25.85 11.05 21.85V24.1Q11.05 29.45 14.875 33.275Q18.7 37.1 24.05 37.1Q25.5 37.1 26.8 36.85Q28.1 36.6 29.25 36.1L31.4 38.25Q29.6 39.25 27.775 39.675Q25.95 40.1 24.05 40.1Q17.5 40.1 12.775 35.375Q8.05 30.65 8.05 24.1V21.85L4.05 25.85L2.1 23.9ZM38.5 31.65 31.05 24.2 33.05 22.2 37 26.15V24.1Q37 18.75 33.175 14.925Q29.35 11.1 24 11.1Q22.55 11.1 21.25 11.375Q19.95 11.65 18.8 12.05L16.65 9.9Q18.45 8.9 20.275 8.5Q22.1 8.1 24 8.1Q30.55 8.1 35.275 12.825Q40 17.55 40 24.1V26.25L44 22.25L45.95 24.2Z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "pan",
    viewBox: "0 0 44 44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 19.3V9.9L18.3 14.1L16.1 11.9L24 4L31.9 11.9L29.7 14.1L25.5 9.9V19.3ZM24 44 15.85 35.85 18.05 33.65 22.5 38.1V28.65H25.5V38.1L29.95 33.65L32.15 35.85ZM36.1 31.9 33.9 29.7 38.1 25.5H28.7V22.5H38.1L33.9 18.3L36.1 16.1L44 24ZM11.9 31.9 4 24 11.95 16.05 14.15 18.25 9.9 22.5H19.35V25.5H9.9L14.1 29.7Z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "zoom-in",
    viewBox: "0 0 44 44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8 41.95 26.65 28.8Q25.15 30.1 23.15 30.825Q21.15 31.55 18.9 31.55Q13.5 31.55 9.75 27.8Q6 24.05 6 18.75Q6 13.45 9.75 9.7Q13.5 5.95 18.85 5.95Q24.15 5.95 27.875 9.7Q31.6 13.45 31.6 18.75Q31.6 20.9 30.9 22.9Q30.2 24.9 28.8 26.65L42 39.75ZM18.85 28.55Q22.9 28.55 25.75 25.675Q28.6 22.8 28.6 18.75Q28.6 14.7 25.75 11.825Q22.9 8.95 18.85 8.95Q14.75 8.95 11.875 11.825Q9 14.7 9 18.75Q9 22.8 11.875 25.675Q14.75 28.55 18.85 28.55ZM20.3 24.3H17.3V20.2H13.2V17.2H17.3V13.15H20.3V17.2H24.35V20.2H20.3Z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "pdf",
    viewBox: "0 0 44 44"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.024,
    height: 42,
    viewBox: "0 0 33.024 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_2",
    "data-name": "Clip 2",
    d: "M0,0H33.024V42H0Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_2-2",
    "data-name": "Clip 2",
    d: "M0,0H33.024V42H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3-2",
    "data-name": "Group 3",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M30.059,42H2.962A2.962,2.962,0,0,1,0,39.046V2.955A2.962,2.962,0,0,1,2.962,0H21.044a.821.821,0,0,1,.116.011l.018.005a.789.789,0,0,1,.093.029l.014.006.02.009a.705.705,0,0,1,.073.04l.014.009.014.009a.615.615,0,0,1,.088.072l11.3,11.256a.21.21,0,0,1,.022.023l.008.009a.07.07,0,0,1,.011.011l.007.007a.667.667,0,0,1,.068.083.014.014,0,0,1,0,.006.654.654,0,0,1,.112.363.117.117,0,0,1,0,.019s0,.008,0,.012V39.046A2.962,2.962,0,0,1,30.059,42ZM2.962,1.313A1.647,1.647,0,0,0,1.313,2.955V39.046a1.648,1.648,0,0,0,1.649,1.642h27.1a1.648,1.648,0,0,0,1.65-1.642V12.607H23.337a2.962,2.962,0,0,1-2.963-2.954V1.313Zm18.725.924V9.653a1.647,1.647,0,0,0,1.65,1.641h7.44Z",
    transform: "translate(0 -0.001)",
    fill: "#434a54"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M1.838,19.39A1.816,1.816,0,0,1,.31,18.647a1.967,1.967,0,0,1-.131-1.886,3.722,3.722,0,0,1,.98-1.255,14.284,14.284,0,0,1,4.718-2.6A27.749,27.749,0,0,0,8.123,7.428a12.29,12.29,0,0,1-1.366-4.97A3.1,3.1,0,0,1,7.015.977,1.694,1.694,0,0,1,8.484,0c.033,0,.066,0,.1,0A1.7,1.7,0,0,1,9.994,1.111a3.421,3.421,0,0,1,.181,1.415,21.384,21.384,0,0,1-.466,3.84c-.061.287-.133.592-.221.931.113.226.23.452.347.673a16.83,16.83,0,0,0,2.075,3.191,16.781,16.781,0,0,1,3.194-.329A12.865,12.865,0,0,1,16.4,10.9a3.768,3.768,0,0,1,1.618.468,1.936,1.936,0,0,1,.968,1.764,1.893,1.893,0,0,1-1.052,1.47,2.962,2.962,0,0,1-1.38.3l-.133,0a7.28,7.28,0,0,1-4.791-2.164c-.056-.053-.111-.107-.165-.161-1.2.269-2.377.631-3.475.981-.463.148-.862.28-1.22.4a35.927,35.927,0,0,1-2.38,3.739A4.276,4.276,0,0,1,2.8,19.181,2.3,2.3,0,0,1,1.838,19.39ZM4.848,14.7a10.707,10.707,0,0,0-2.835,1.767,2.469,2.469,0,0,0-.655.8.709.709,0,0,0,0,.646.566.566,0,0,0,.477.194,1.006,1.006,0,0,0,.419-.09A3.216,3.216,0,0,0,3.35,16.937C3.876,16.213,4.38,15.461,4.848,14.7Zm10.258-2.581a14.437,14.437,0,0,0-2.051.154,5.8,5.8,0,0,0,3.392,1.338H16.5a1.85,1.85,0,0,0,.841-.154.632.632,0,0,0,.359-.44.68.68,0,0,0-.362-.557,2.593,2.593,0,0,0-1.073-.284A11.515,11.515,0,0,0,15.106,12.118ZM8.96,9.055h0a29.87,29.87,0,0,1-1.348,3.269c.91-.291,1.892-.594,2.9-.847A18.347,18.347,0,0,1,8.96,9.055ZM8.495,1.283h0a.441.441,0,0,0-.332.267,1.89,1.89,0,0,0-.124.87,9.318,9.318,0,0,0,.573,2.849,19.906,19.906,0,0,0,.279-2.783,2.331,2.331,0,0,0-.089-.9A.462.462,0,0,0,8.5,1.284Z",
    transform: "translate(7.017 14.457)",
    fill: "#434a54"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCytiva);
export default __webpack_public_path__ + "static/media/cytiva.2f61c0d51a6515ede8008b2826f4054e.svg";
export { ForwardRef as ReactComponent };